import { FC } from 'react';

import { useFormatter } from '@eneco/i18n';
import { Stack, Text } from '@eneco/sparky';

export const TariffAndUsageDetails: FC<{
  tariff?: number;
  usage?: number;
  total?: number;
}> = ({ tariff = 0, usage = 0, total = 0 }) => {
  const { currency, unit } = useFormatter();

  return (
    <Stack direction="row" alignY="end" gap="2">
      <Stack.Item grow={true}>{`${currency.euroFiveDecimals(tariff)} × ${unit.electricity(usage)} = `}</Stack.Item>
      <Stack.Item shrink={false}>{currency.euro(total)}</Stack.Item>
    </Stack>
  );
};

export const LabelAndTariffAndUsageDetails: FC<{
  label: string;
  tariff?: number;
  usage?: number;
}> = ({ label, tariff = 0, usage = 0 }) => {
  const { currency, unit } = useFormatter();

  return (
    <Stack.Item>
      <Stack direction="row" alignY="start" gap="2">
        <Stack.Item grow={true}>
          <Stack direction="column" gap="2">
            <Stack direction="row" alignY="end" gap="2">
              <Stack.Item grow={true}>
                <Text>{label}</Text>
                {`${unit.electricity(usage)} `}
              </Stack.Item>
              <Stack.Item shrink={false}>{currency.euroFiveDecimals(tariff) ?? 0}</Stack.Item>
            </Stack>
          </Stack>
        </Stack.Item>
      </Stack>
    </Stack.Item>
  );
};
